// Set this to a non-empty string to show a site-wide announcement banner.
// Clear it (set to "") to hide the banner. Dismissed state is keyed on the
// message text, so changing the text will re-show the banner for all visitors.
export const ANNOUNCEMENT = `Regulation M-C is here!`;
